/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
/* tslint:disable */
// @ts-nocheck
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.
import { ChevronDown } from '@elliemae/ds-icons';
import { styled } from '@elliemae/ds-system';

export const MobileDropdownInput = styled.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  -webkit-tap-highlight-color: transparent;
  caret-color: transparent;
  padding-right: 32px;
  padding-left: 10px;
  border-radius: 2px;
  width: 100%;
  background: ${(props) => props.theme.colors.neutral['000']};
  height: 32px;
  line-height: 32px;
  border: solid 1px ${(props) => props.theme.colors.neutral[200]};

  &:active,
  &:focus {
    outline: none;
    border: 1px solid ${({ theme }) => theme.colors.brand[700]};
    border-radius: 2px;
  }
`;

export const MobileDropdownInputWrap = styled.span`
  position: relative;
  width: 100%;
  display: inline-block;
  height: 32px;
`;

const CaretWrap = styled.span`
  width: 32px;
  height: 32px;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Caret = ({ onClick }): JSX.Element => (
  <CaretWrap onClick={onClick}>
    <ChevronDown color={['brand-primary', '600']} />
  </CaretWrap>
);

export const DSMobileDropdownTriggerInput = ({
  inputProps,
  caretProps,
  selectedItemsText,
}: {
  inputProps: Record<string, unknown>;
  caretProps: Record<string, unknown>;
  selectedItemsText?: string;
}): JSX.Element => (
  <MobileDropdownInputWrap data-testid="ds-mobile-ddwn-menu">
    <MobileDropdownInput {...inputProps} readOnly value={selectedItemsText ?? inputProps.value} />

    <Caret {...caretProps} />
  </MobileDropdownInputWrap>
);
